/* eslint-disable */
/**
 * Accordion GTM Tracking
 * Tracks accordion expand/collapse interactions and captures related URLs
 */

/**
 * Extract all URLs from the content
 * @param {HTMLElement} contentElement - The accordion content element
 * @returns {Array} Array of URL objects with href and text
 */
function extractUrls(contentElement) {
    const links = contentElement.querySelectorAll('a[href]');
    const urls = [];

    links.forEach(link => {
        urls.push({
            url: link.href,
            text: link.textContent.trim()
        });
    });

    return urls;
}

/**
 * Get the accordion section title (parent accordion block title)
 * @param {HTMLElement} button - The accordion button element
 * @returns {string} The section title
 */
function getAccordionSection(button) {
    const accordionBlock = button.closest('[id^="accordion-"]');
    if (accordionBlock) {
        const sectionTitle = accordionBlock.querySelector('[data-accordion-section]');
        if (sectionTitle) {
            return sectionTitle.getAttribute('data-accordion-section') || 'Unknown Section';
        }
    }
    return 'Unknown Section';
}

/**
 * Push accordion interaction to GTM dataLayer
 * @param {Object} eventData - The event data to push
 */
function pushToDataLayer(eventData) {
    if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push(eventData);
        console.log('GTM Event Pushed:', eventData);
    } else {
        console.warn('dataLayer not available, event not tracked:', eventData);
    }
}

/**
 * Handle accordion button click
 * @param {Event} event - The click event
 */
function handleAccordionClick(event) {
    const button = event.currentTarget;
    const accordionTitle = button.getAttribute('data-accordion-title') || 'Unknown Title';
    const accordionSection = getAccordionSection(button);

    const wasExpanded = button.getAttribute('aria-expanded') === 'true';
    const isExpanding = !wasExpanded;

    const contentId = button.getAttribute('aria-controls');
    const contentElement = contentId ? document.getElementById(contentId) : button.nextElementSibling;

    const eventData = {
        event: 'accordion_interaction',
        accordion_action: isExpanding ? 'expand' : 'collapse',
        accordion_selection: accordionTitle,
        accordion_title: accordionSection,
        accordion_url: window.location.href,
        accordion_path: window.location.pathname
    };

    if (isExpanding && contentElement) {
        const urls = extractUrls(contentElement);
        if (urls.length > 0) {
            eventData.accordion_links = urls;
            eventData.accordion_link_count = urls.length;
        }
    }

    pushToDataLayer(eventData);
}

/**
 * Initialize accordion tracking
 */
export function initAccordionTracking() {
    const accordionButtons = document.querySelectorAll('.js-accordion-track');

    accordionButtons.forEach(button => {
        button.removeEventListener('click', handleAccordionClick);
        button.addEventListener('click', handleAccordionClick);
    });

    console.log('Accordion tracking initialized for', accordionButtons.length, 'accordions');
}

/**
 * Track clicks on links within accordion content
 * @param {Event} event - The click event
 */
function handleAccordionLinkClick(event) {
    const link = event.currentTarget;
    const accordionContent = link.closest('.nx-accordion__content');

    if (accordionContent) {
        const accordionButton = accordionContent.previousElementSibling;
        if (accordionButton && accordionButton.classList.contains('js-accordion-btn')) {
            const accordionTitle = accordionButton.getAttribute('data-accordion-title') || 'Unknown Title';
            const accordionSection = getAccordionSection(accordionButton);

            pushToDataLayer({
                event: 'accordion_link_click',
                accordion_selection: accordionTitle,
                accordion_title: accordionSection,
                link_url: link.href,
                link_text: link.textContent.trim(),
                page_url: window.location.href,
                page_path: window.location.pathname
            });
        }
    }
}

/**
 * Initialize link tracking within accordions
 */
export function initAccordionLinkTracking() {
    const accordionLinks = document.querySelectorAll('.nx-accordion__content a[href]');

    accordionLinks.forEach(link => {
        link.removeEventListener('click', handleAccordionLinkClick);
        link.addEventListener('click', handleAccordionLinkClick);
    });

    console.log('Accordion link tracking initialized for', accordionLinks.length, 'links');
}

/**
 * Initialize all accordion tracking (used for re-initialization on dynamic content)
 */
export function reinitAccordionTracking() {
    initAccordionTracking();
    initAccordionLinkTracking();
}

